import { tokenAxios } from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";
import { TaoUsersArgs, TaoUsersList } from "@/types/tao-routing";
import { useAppState } from "@/contexts/app-state";
import { buildApiUrl } from "@/utils/api";

const getTaoUsers = async (params: TaoUsersArgs) => {
  // @eslint-disable-line
  const { data } = await tokenAxios().get<TaoUsersList[]>(buildApiUrl("taoadmin"), { params });
  return data;
};

export const useTaoUsers = () => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;


  return useQuery<TaoUsersList[], Error>({
    queryKey: ["Tao-Routing-Users", practiceId, requestedUser],
    queryFn: () => getTaoUsers({ practiceId, requestedUser }),
  });
};
